import React, { Component } from 'react';

import {Download} from './shared/Icons';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';

class AppDownload extends Component {

  render() {
    const downloadLink = this.props.appLink;

    return (
      <div className="appdownload">
        <p style={{marginBottom:'2rem', fontSize: '1rem', textTransform:'none',}}>
          <FormattedMessage
            id='Client.Lobby.HintApp'
            defaultMessage='Um an diesem Video-Anruf teilzunehmen brauchen Sie die Nextcare Pro App.' />
        </p>
        <a href={downloadLink} className="call roundIcon nextcarebutton" style={{padding: '12px', justifyContent: 'flex-start'}}>
          <img src="nextcare-icon.png" />
          <div style={{textAlign:'left', marginLeft:'1rem'}}>
            Nextcare Pro
            <br />
            <span className="subline">
              <FormattedMessage
                  id='Client.Lobby.InstallApp'
                  defaultMessage='Jetzt installieren' />
            </span>
          </div>
          <div style={{flex:1, textAlign:'right'}}>
            <Download />
          </div>
        </a>
        <p className="hint" style={{textTransform: 'none', marginTop:'2rem'}}>
          <FormattedMessage
            id='Client.Lobby.AlreadyInstalled'
            defaultMessage='Schon installiert?' />
        </p>
        <a style={{textTransform:'none!important', border:'1px solid #555', padding:'5px 10px', borderRadius: '15px', color: 'inherit'}} href={"pro.nextcare.companionapp://" + window.location.href.replace('https://', '')}>
          <span>
            <FormattedMessage
              id='Client.Lobby.ContinueInApp'
              defaultMessage='Weiter zur App' />
          </span>
        </a>
      </div>
    )
  }
};

export default AppDownload;


// WEBPACK FOOTER //
// ./src/AppDownload.js